import { Badge } from "@freightsimple/ui-core/Display/Badge";

interface CurrencyTagProps {
  currency: "USD" | "CAD";
}

// Tiny blue pill marking which currency an organization bills in (nav bar,
// switch-organization list). A small info Badge — the pill shape, blue tint and
// bold type it used to hand-roll are exactly what Badge already owns.
export function CurrencyTag({ currency }: CurrencyTagProps) {
  return <Badge label={currency} variant="info" size="small" />;
}
